import React from 'react';
import { Layout, Typography, Space, Row, Col } from 'antd';
import { GithubOutlined, WechatOutlined, QqOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './index.css';

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

const Footer = () => {
    const navigate = useNavigate();

    const handleSearch = (value) => {
        if (value.trim()) {
            // 导航到搜索结果页面，这里简单地跳转到首页并带上搜索参数
            navigate(`/?search=${encodeURIComponent(value)}`);
        }
    };

    return (
        <AntFooter className="app-footer">
            <div className="footer-content">
                <Row gutter={[24, 24]} justify="center">
                    <Col>
                        <div className="footer-section">
                            <Space size="large" className="social-links">
                                <Link href="#" target="_blank" title="GitHub">
                                    <GithubOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
                                </Link>
                                <Link href="#" target="_blank" title="微信">
                                    <WechatOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
                                </Link>
                                <Link href="#" target="_blank" title="QQ">
                                    <QqOutlined style={{ fontSize: '24px', color: 'rgba(0, 0, 0, 0.65)' }} />
                                </Link>
                            </Space>
                        </div>
                    </Col>
                </Row>
                <div className="footer-bottom">
                    <Text>© 2025 我的博客. All Rights Reserved.</Text>
                    <div>
                        <Text type="secondary" style={{ display: 'block', marginTop: 8 }}>Proudly powered by React & Ant Design</Text>
                    </div>
                </div>
            </div>
        </AntFooter>
    );
};

export default Footer;